"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AuthContext = require("../AuthContext");
var _reducers = require("../utils/reducers");
function useSignOut() {
  var context = (0, _AuthContext.useReactAuthKit)();
  return function () {
    context.set((0, _reducers.doSignOut)());
  };
}
var _default = exports.default = useSignOut;